module.exports = __webpack_public_path__ + "static/img/female-bg-en.788f8a22.png";